<div class="cp-import-container custom-grid" [title]="control.iconTooltip" [hidden]="isHidden">
    @if (onlyIcon) {
        <button mat-icon-button [disabled]="isDisabled" (click)="onClick()">
            <mat-icon> {{ control.icon }} </mat-icon>
        </button>
    } @else {
        <button class="action-button" mat-stroked-button (click)="onClick()" [disabled]="isDisabled">
            <mat-icon class="icon"> {{ control.icon }} </mat-icon>
            @if (control.isWithLabel) {
                <span class="label">{{ control.name | translate }}</span>
            }
        </button>
    }
</div>
